<template>
  <div class="message-content">
    <a-modal
      v-drag-modal
      :title="null"
      width="60%"
      :mask="false"
      :maskClosable="false"
      :body-style="{ padding: 0 }"
      :dialog-style="{ top: '100px' }"
      :visible="localVisiable"
      @cancel="localVisiable = false"
      :footer="null"
    >
      <a-spin :spinning="loading" tip="图片发送中...">
        <div class="main">
          <div class="header">
            <span class="user-name">{{ user_detail.nick_name }}</span>
          </div>
          <div class="main-scrollbar" id="m-list">
            <div class="user-message-content cm-list">
              <div
                class="cm-item"
                :key="item.customer_message_id"
                v-for="item in current_cm_list"
              >
                <div class="time-title">{{ item.time_str }}</div>
                <div
                  class="main-message"
                  :class="{ merchant: item.message_from === 'merchant' }"
                >
                  <a-avatar
                    class="cm-item-avatar"
                    icon="user"
                    style="background-color: #87d068"
                    v-if="item.message_from === 'merchant'"
                  />
                  <a-avatar class="cm-item-avatar" :src="item.avatar" v-else />
                  <div class="user-message-item">
                    <div
                      class="content-info img-info"
                      v-if="item.msg_type === 'image'"
                    >
                      <img
                        class="msg-img"
                        @click="handlePreviewImage(item.content)"
                        width="100px"
                        :src="item.content"
                        alt="图片"
                      />
                    </div>
                    <div v-else class="content-info" v-html="item.content" />
                    <span class="send-fail" v-if="item.send_fail"
                      >发送失败</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div
              class="new-cm-tips"
              v-if="show_new_cm_tips"
              @click="resetTop(1)"
            >
              <a-icon type="double-right" class="rotate90" />{{
                new_cm_tips_num
              }}条新消息
            </div>
          </div>
          <div class="input-content" v-show="user_detail.open_id">
            <div class="operate-content">
              <a-upload
                name="file"
                :multiple="true"
                :action="uploadFile"
                accept="image/jpg,image/jpeg,image/png"
                @change="handleChange"
                :showUploadList="false"
              >
                <img
                  src="../../assets/image/upload-img.png"
                  class="upload-img"
                  width="20"
                  alt="img"
                />
              </a-upload>
              <a-tooltip
                trigger="click"
                placement="topLeft"
                v-model="emoji_visiable"
              >
                <template slot="title">
                  <div class="emoji-list">
                    <span
                      class="emoji-item"
                      v-for="item in emoji"
                      :key="item"
                      @click="chosseEmoji(item)"
                      >{{ item }}
                    </span>
                  </div>
                </template>
                <a-icon type="smile" class="icon-tab" />
              </a-tooltip>
            </div>
            <a-textarea
              class="message-input"
              v-model="input_content"
              :auto-size="false"
              ref="textarea"
              @keydown="keyUpHandle"
            />
            <a-button
              type="primary"
              shape="round"
              class="send-btn"
              @click="sendMessage(false)"
              >发送</a-button
            >
          </div>
        </div>
      </a-spin>
      <aside>
        <header class="flex-c-c">
          <div class="search">
            <a-input-search
              allowClear
              placeholder="搜索用户"
              v-model="search_content"
              class="search-input"
            />
          </div>
        </header>
        <a-spin :spinning="user_loading">
          <div class="tab-list">
            <div
              class="tab-item"
              :class="{ active: is_reply === 0 }"
              @click="changeReadStatus(0)"
            >
              <a-badge dot :count="has_new_msg ? 1 : 0">未回复</a-badge>
            </div>
            <div
              class="tab-item"
              :class="{ active: is_reply === 1 }"
              @click="changeReadStatus(1)"
            >
              已回复
            </div>
          </div>
          <div class="sidebar-scrollbar">
            <div class="sidebar-content">
              <div
                v-for="item in user_list_show"
                :key="item.open_id"
                class="user-item"
                :class="{ active: item.open_id === user_detail.open_id }"
                @click="selectItem(item)"
              >
                <a-badge dot :count="item.read ? 0 : 1">
                  <a-avatar shape="square" :size="36" :src="item.avatar" />
                </a-badge>
                <div class="text-content">
                  <div class="line1">
                    <span class="user-name">{{ item.nick_name }}</span>
                    <span class="time">{{ item.time }}</span>
                  </div>
                  <div class="line2">
                    <p class="no-margin h20" v-if="item.text">
                      <span class="red">[草稿]</span>
                      <span class="cg-text">{{ item.text }}</span>
                    </p>
                    <span v-else class="last-message">{{
                      item.msg_type === "image" ? "[图片]" : item.content
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a-spin>
      </aside>
      <div class="order-info" v-if="user_detail.open_id">
        <div class="order-title">最近一个订单</div>
        <div class="order-info-detail" v-if="order_detail">
          <div class="detail-item">
            <span class="label">订单号：</span>
            {{ order_detail.platform_order_sn }}
          </div>
          <div class="detail-item">
            <span class="label">uid：</span>{{ order_detail.uid }}
          </div>
          <div class="detail-item">
            <span class="label">用户昵称：</span>{{ order_detail.user_nick }}
          </div>
          <div class="detail-item">
            <span class="label">平台用户注册时间：</span>
            {{ order_detail.user_registration_time }}
          </div>
          <div class="detail-item">
            <span class="label">商品名称/数量：</span>
            <div
              class="goods-item"
              v-for="item in order_detail.order_goods_list"
              :key="item.goods_id"
            >
              {{ item.goods_name }}/{{ item.goods_number }}份
            </div>
          </div>
          <div class="detail-item">
            <span class="label">下单时间：</span>{{ order_detail.order_time }}
          </div>
          <div class="detail-item">
            <span class="label">支付时间：</span>{{ order_detail.pay_time }}
          </div>
          <div class="detail-item">
            <span class="label">收件人姓名：</span
            >{{ order_detail.receiver_name }}
          </div>
          <div class="detail-item">
            <span class="label">手机号：</span>{{ order_detail.mobile }}
          </div>
          <div class="detail-item">
            <span class="label">收件地址：</span>
            {{ order_detail.province_name }}
            {{ order_detail.city_name }}
            {{ order_detail.district_name }}
            {{ order_detail.shipping_address }}
          </div>
        </div>
        <div class="no-order" v-else>
          暂无订单
          <div class="detail-item">
            <span class="label">uid：</span>{{ user_detail.open_id }}
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal
      :visible="preview_visible"
      :footer="null"
      :title="null"
      dialog-class="img-dialog"
      :body-style="{ padding: 0 }"
      :dialog-style="{ top: '20px' }"
      @cancel="preview_visible = false"
    >
      <img
        alt="example"
        style="width: 100%; display: block"
        :src="preview_image"
      />
      <!-- <div class="header"></div> -->
    </a-modal>
  </div>
</template>
<script>
import { formatDate, debounce, changeBlobImageQuality } from "@common/common";
import { Modal } from "ant-design-vue";
import axios from "axios";
import OSocket from "@common/socket.js";
import emoji from "@common/emoji.js";
import { wsURL, baseURL } from "../../config/config.js";
let ws = null; // 判断当前浏览器是否支持WebSocket
export default {
  name: "message",
  props: ["visiable"],
  computed: {
    localVisiable: {
      get() {
        return this.visiable;
      },
      set(data) {
        this.$emit("update:visiable", data);
        if (!data) {
          document
            .querySelector(".sidebar-scrollbar")
            .removeEventListener("scroll", debounce(this.userScrollHandle));
          document
            .querySelector(".cm-list")
            .removeEventListener("scroll", debounce(this.cmScrollHandle));
          document
            .querySelector(".message-input")
            .removeEventListener("paste", this.pasteImage);
        }
      },
    },
    user_list_show() {
      return this.search_content
        ? this.user_cm_list.filter(
            (item) => item.nick_name.indexOf(this.search_content) !== -1
          )
        : this.user_cm_list;
    },
    uploadFile() {
      return baseURL + this.$api.uploadFile;
    },
  },
  data() {
    return {
      search_content: "",
      input_content: "",
      user_cm_list: [], //用户列表
      create_time_for_item: "", //个人传递时间
      create_time_for_list: "", //列表传递时间
      user_detail: {}, //当前选择用户
      current_cm_list: [], //当前聊天内容
      last_scroll_height: 0,
      select_io: true,
      request_io: true,
      preview_image: "",
      preview_visible: false,
      loading: false,
      new_cm_tips_num: 0, //不在最底部显示x条新消息
      show_new_cm_tips: false, //不在最底部显示x条新消息
      order_detail: null,
      emoji,
      emoji_visiable: false,
      is_reply: 0, //是否已回复
      has_new_msg: 0,
      user_loading: true,
    };
  },
  mounted() {
    ws = new OSocket();
    ws.createWebSocket(
      wsURL + "/cm_websocket",
      () => {
        this.user_cm_list = [];
        this.create_time_for_list = "";
        this.create_time_for_item = "";
        this.user_detail = {};
        this.current_cm_list = [];
      },
      (data) => {
        this.getMessage(data);
      }
    );
  },
  beforeDestroy() {
    ws.needReconnect = false;
    ws.ws.close();
  },
  methods: {
    scrollInit() {
      //用户列表下拉加载更多
      document
        .querySelector(".sidebar-scrollbar")
        .addEventListener("scroll", debounce(this.userScrollHandle));
      //聊天内容上拉加载更多
      document
        .querySelector(".cm-list")
        .addEventListener("scroll", debounce(this.cmScrollHandle));
      // 【截图粘贴图片】
      document
        .querySelector(".message-input")
        .addEventListener("paste", this.pasteImage);
    },
    getMessage(data) {
      // console.log(data);
      if (data.type === "user_list") {
        //获取用户列表
        this.create_time_for_list = data.result.create_time || null;
        this.request_io = true;
        let list = [...data.result.list];
        if (list.length) {
          let date = new Date();
          list.forEach((item) => {
            let distinctTime = date.getTime() - item.create_time * 1000;
            let _time = new Date(parseInt(item.create_time) * 1000);
            if (
              distinctTime <= 24 * 3600 * 1000 &&
              _time.getDate() === date.getDate()
            ) {
              item.time = formatDate(item.create_time, "H:I");
            } else {
              item.time = formatDate(item.create_time, "Y/M/D", false, true);
            }
          });
          list = [...this.user_cm_list, ...list];
          this.user_cm_list = list;
          this.user_loading = false;
        }
      } else if (data.type === "new_cm") {
        //获取新发的消息
        if (!this.localVisiable) {
          this.$emit("iconTip");
        }
        let new_cm = data.result,
          user_detail = this.user_detail,
          current_cm_list = [...this.current_cm_list];
        if (user_detail.open_id === new_cm.open_id) {
          new_cm.read = 1;
          let show_new_cm_tips = true;
          if (this.judgeScrollBottom()) {
            //在最底部 50px 附近 直接resetTop(1)
            show_new_cm_tips = false;
          }
          current_cm_list.push(new_cm);
          this.current_cm_list = current_cm_list;
          this.$nextTick(() => {
            if (!show_new_cm_tips) {
              this.resetTop(1);
            } else {
              this.new_cm_tips_num++;
            }
            this.show_new_cm_tips = show_new_cm_tips;
          });
          let data = {
            customer_message_id: new_cm.customer_message_id,
            type: "cm_read",
          };
          ws.send(JSON.stringify(data));
        } else {
          new_cm.read = 0;
        }
        new_cm.time = formatDate(new_cm.create_time, "H:I");
        this.freshList(new_cm);
      } else if (data.type === "cm_list") {
        //获取个人聊天记录
        let list = [...data.result.list];
        list.forEach((item, index) => {
          item.content = item.content.replace(/(\r\n|\n|\r)/gm, "<br />");
          let time_str = this.compareTime(item, list[index + 1]);
          item.time_str = time_str;
        });
        list.reverse();
        if (list.length) {
          list = [...list, ...this.current_cm_list];
          this.current_cm_list = list;
          this.$nextTick(() => {
            this.resetTop();
          });
        }
        this.create_time_for_item = data.result.create_time || null;
        this.request_io = true;
        this.select_io = true;
      }
    },
    //判断滑动是否在最底部
    judgeScrollBottom() {
      let $cm = document.querySelector(".cm-list"),
        scrollHeight = $cm.scrollHeight,
        scrollTop = $cm.scrollTop,
        offsetHeight = $cm.offsetHeight;
      return scrollHeight - (scrollTop + offsetHeight) <= 50;
    },
    //刷新用户列表
    freshList(new_cm) {
      /**
       * 客户发送的消息
       * 在未回复列表，插入新数据、在已回复列表，没有变化
       * 客服自己发送的消息
       * 在未回复列表，没有变化、在已回复列表，插入新数据
       */
      let list = [...this.user_cm_list];
      let index = list.findIndex((item) => {
        return item.open_id === new_cm.open_id;
      });
      if (~index) {
        new_cm.avatar = list[index].avatar || new_cm.avatar;
        new_cm.nick_name = list[index].nick_name || new_cm.nick_name;
        list.splice(index, 1);
      }
      if (this.is_reply) {
        if (new_cm.message_from === "merchant") {
          list.unshift(new_cm);
        } else {
          //未回复亮红色小点点
          this.has_new_msg = 1;
        }
      } else {
        if (new_cm.message_from !== "merchant") {
          list.unshift(new_cm);
        }
      }
      this.user_cm_list = list;
    },
    pasteImage(event) {
      const items = (event.clipboardData || window.clipboardData).items;
      for (var i = 0; i < items.length; ++i) {
        // 如果剪贴板中的内容类型是图片文件
        if (items[i].kind == "file" && items[i].type.indexOf("image/") >= 0) {
          event.preventDefault();
          var blob = items[i].getAsFile();
          changeBlobImageQuality(blob, (newBlob) => {
            this.uploadPaseImage(newBlob);
          });
        }
      }
    },
    uploadPaseImage(file) {
      let data = new FormData();
      data.append("file", file);
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      axios.post(this.uploadFile, data, config).then((response) => {
        let url = response.data.result.oss_file_url;
        this.sendMessage(url);
      });
    },
    keyUpHandle(event) {
      if (!event.shiftKey && event.keyCode == 13) {
        event.cancelBubble = true;
        event.preventDefault();
        event.stopPropagation();
        this.sendMessage(false);
      }
    },
    isEmpty(str) {
      str = str.replace(/(\r\n|\n|\r)/gm, "");
      return str.length === 0;
    },
    sendMessage(img_url = "") {
      if (this.isEmpty(this.input_content) && !img_url) return;
      if (!this.request_io) return;
      this.request_io = false;
      let data = {
        cm: {
          open_id: this.user_detail.open_id,
        },
      };
      if (img_url) {
        //发送图片
        data.cm.message = img_url;
        data.cm.msg_type = "image";
      } else {
        data.cm.message = this.input_content;
        data.cm.msg_type = "text";
      }
      this.$axios({
        url: this.$api.sendCM,
        data,
      }).then((res) => {
        this.request_io = true;
        if (res.result.type === "send_cm_success") {
          let message = res.result.cm;
          message.message_from = "merchant";
          message.read = 1;
          message.content = message.message.replace(/(\r\n|\n|\r)/gm, "<br />");
          message.time = formatDate(message.create_time, "H:I");
          message.msg_type = img_url ? "image" : "text";
          this.current_cm_list.push(message);
          this.freshList(message);
          this.$nextTick(() => {
            this.input_content = "";
            this.resetTop(1);
          });
        } else {
          Modal.error({
            title: "温馨提示",
            content: res.result.cm.errmsg || "发送失败",
          });
        }
      });
    },
    compareTime(item1, item2) {
      if (!item2) return formatDate(item1.create_time, "Y/M/D H:I", false);
      let time_str = "";
      let distinctTime = (item1.create_time - item2.create_time) * 1000;
      let _time1 = new Date(parseInt(item1.create_time) * 1000);
      if (
        distinctTime >= 10 * 60 * 1000 &&
        _time1.getDate() === new Date().getDate()
      ) {
        time_str = formatDate(item1.create_time, "H:I");
      } else if (
        distinctTime >= 10 * 60 * 1000 &&
        _time1.getDate() !== new Date().getDate()
      ) {
        time_str = formatDate(item1.create_time, "Y/M/D H:I", false);
      }
      return time_str;
    },
    selectItem(item) {
      if (!this.select_io) {
        return;
      }
      if (this.user_detail && this.user_detail.open_id === item.open_id) {
        return;
      }
      item.read = 1;
      if (this.input_content) {
        this.$set(this.user_detail, "text", this.input_content);
      }
      this.last_scroll_height = 0;
      this.current_cm_list = [];
      this.select_io = false;
      this.create_time_for_item = "";
      let data = {
        type: "cm_list",
        open_id: item.open_id,
      };
      ws.send(JSON.stringify(data));
      let data2 = {
        customer_message_id: item.customer_message_id,
        type: "cm_read",
      };
      ws.send(JSON.stringify(data2));
      this.user_detail = item;
      this.$nextTick(() => {
        this.getOrderByUid();
        this.input_content = item.text || "";
        this.resetTop(1);
      });
    },
    //获取当前用户的订单
    getOrderByUid() {
      this.$axios({
        url: this.$api.getOrderByUid,
        data: {
          uid: this.user_detail.open_id,
        },
      }).then((res) => {
        this.order_detail = res.result.order;
      });
    },
    //用户列表上滑加载下一页
    userScrollHandle(event) {
      if (!this.request_io) {
        event.preventDefault();
        return;
      }
      let clientHeight = event.target.clientHeight,
        scrollTop = event.target.scrollTop,
        scrollHeight = event.target.scrollHeight;
      if (
        clientHeight + scrollTop >= scrollHeight - 150 &&
        this.create_time_for_list !== null
      ) {
        let data = {
          type: "user_list",
          last_create_time: this.create_time_for_list,
          is_reply: this.is_reply,
        };
        this.request_io = false;
        ws.send(JSON.stringify(data));
      }
    },
    //聊天记录下滑加载下一页
    cmScrollHandle(event) {
      if (!this.select_io || !this.request_io) {
        event.preventDefault();
        return;
      }
      // console.log(event);
      this.last_scroll_height = event.target.scrollHeight;
      //往上滑动距离顶部小于100请求下一页
      if (
        event.target.scrollTop <= 100 &&
        this.create_time_for_item !== null &&
        this.request_io
      ) {
        let data = {
          type: "cm_list",
          open_id: this.user_detail.open_id,
          last_create_time: this.create_time_for_item,
        };
        this.request_io = false;
        // console.log("next page");
        ws.send(JSON.stringify(data));
      } else if (
        event.target.scrollHeight -
          (event.target.scrollTop + event.target.offsetHeight) <=
        50
      ) {
        this.clearNewCmTips();
      }
    },
    resetTop(neednot = false) {
      this.$refs.textarea.focus();
      let $cm = document.querySelector(".cm-list"),
        scrollHeight = $cm.scrollHeight,
        scrollTop;
      this.loadImageToDo().then(() => {
        if (this.last_scroll_height && !neednot) {
          scrollTop = scrollHeight - this.last_scroll_height;
        } else {
          scrollTop = scrollHeight;
          this.clearNewCmTips();
        }
        $cm.scrollTop = scrollTop;
      });
    },
    clearNewCmTips() {
      this.new_cm_tips_num = 0;
      this.show_new_cm_tips = false;
    },
    loadImageToDo() {
      //获取所有图片 等图片加载完了在滚动
      return new Promise((resolve) => {
        let cm_list = document.getElementById("m-list");
        let imgs = cm_list.querySelectorAll(".msg-img");
        let imglength = imgs.length;
        let count = 0;
        function loadFinishJudge() {
          count++;
          if (count === imglength) {
            //图片都加载完了
            resolve();
          }
        }
        if (imglength) {
          for (let img of imgs) {
            if (img.hasLoad) {
              loadFinishJudge();
            }
            img.onload = () => {
              img.hasLoad = true;
              loadFinishJudge();
            };
            img.onerror = (err) => {
              console.log("图片加载出错", err);
              img.hasLoad = true;
              loadFinishJudge();
            };
          }
        } else {
          resolve();
        }
      });
    },
    handlePreviewImage(img_url) {
      this.preview_image = img_url;
      this.preview_visible = true;
    },
    handleChange(info) {
      if (info.file.status !== "uploading") {
        // console.log(info.file, info.fileList);
        let url = info.file.response.result.oss_file_url;
        this.sendMessage(url);
      }
      // if (info.file.status === "done") {
      //   this.$message.success(`${info.file.name} file uploaded successfully`);
      // } else
      if (info.file.status === "error") {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
    chosseEmoji(emoji) {
      this.input_content += emoji;
      this.emoji_visiable = false;
      this.$refs.textarea.focus();
    },
    changeReadStatus(status) {
      if (this.is_reply === status) return;
      this.is_reply = status;
      let data = {
        type: "user_list",
        is_reply: this.is_reply,
      };
      this.user_cm_list = [];
      if (status === 0) {
        this.has_new_msg = 0;
      }
      this.user_loading = true;
      ws.send(JSON.stringify(data));
    },
  },
};
</script>
<style>
.ant-modal .ant-input {
  background-color: #f3f3f3;
}
.ant-tooltip-inner {
  background-color: #fff;
}
.ant-tooltip {
  max-width: 500px;
}
</style>
<style lang="scss" scoped>
@import "@assets/css/mixin.scss";
.main {
  .header {
    height: 60px;
    width: 100%;
    padding-left: 260px;
    display: flex;
    align-items: center;
    background-color: #f3f3f3;
    border-bottom: 1px solid #ddd;
    .user-name {
      font-size: 16px;
      font-weight: 500;
      padding-left: 16px;
    }
  }
}
/* sidebar */
aside {
  position: absolute;
  top: 0;
  left: 0;
  width: 260px;
  height: 100%;
  // box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  border-right: 1px solid #ddd;
  background-color: #f3f3f3;
  header {
    height: 60px;
    background-color: #f7f7f7;
    border-bottom: 1px solid #ddd;
    .search-input {
      width: 220px;
    }
  }
  /* sidebar scrollbar wrapper */
  .sidebar-scrollbar {
    position: relative;
    height: calc(70vh - 60px - 30px);
    background-color: #f7f7f7;
  }
  .sidebar-content {
    .user-item {
      background-color: #f7f7f7;
      width: 100%;
      padding: 10px;
      border-bottom: 1px solid #fff;
      display: flex;
      align-items: center;
      &.active {
        background-color: #d3d5dc;
      }
      .text-content {
        width: 100%;
        margin-top: 5px;
        margin-left: 12px;
        display: flex;
        flex-direction: column;
        .line1 {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .user-name {
            display: block;
            font-weight: bold;
            color: #333;
            font-size: 14px;
            width: 90px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .time {
            font-size: 10px;
            color: #999;
            text-align: right;
            width: 60px;
          }
        }
        .h20 {
          height: 20px;
          .cg-text {
            font-size: 12px;
            color: #999;
            display: inline-block;
            width: 100px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-left: 2px;
          }
        }
        .last-message {
          font-size: 12px;
          color: rgba(51, 51, 51, 0.5);
          display: inline-block;
          width: 186px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .red {
          display: inline-block;
          font-size: 12px;
          color: #ec4958;
          overflow: hidden;
        }
      }
    }
  }
  .tab-list {
    display: flex;
    .tab-item {
      cursor: pointer;
      width: 100%;
      text-align: center;
      font-size: 14px;
      background-color: #f7f7f7;
      height: 30px;
      line-height: 30px;
      &.active {
        color: $primary-color;
        border-bottom: 1px solid $primary-color;
      }
    }
  }
}
/* main content */
.main {
  height: 70vh;
  background-color: #f3f3f3;
  /* main scrollbar wrapper */
  .main-scrollbar {
    margin-left: 260px;
    height: calc(100% - 60px - 150px);
    position: relative;
    .new-cm-tips {
      position: absolute;
      display: inline-block;
      left: 50%;
      transform: translateX(-50%);
      bottom: 10px;
      box-shadow: 0 0 4px rgba(0, 0, 0, 0.5);
      border-radius: 100px;
      text-align: center;
      color: #00c269;
      background-color: #fff;
      font-size: 12px;
      padding: 4px 10px;
      cursor: pointer;
      .rotate90 {
        transform: rotate(90deg);
        margin-right: 4px;
        font-size: 10px;
      }
    }
  }
  .input-content {
    margin-left: 260px;
    height: 150px;
    border-top: 1px solid #ddd;
    position: relative;
    padding: 10px 16px;
    .operate-content {
      .upload-img {
        cursor: pointer;
      }
    }
    textarea {
      resize: none;
      background-color: #f3f3f3;
      border: none;
      height: calc(100% - 30px);
      padding: 0;
      &:focus,
      &:hover {
        border: none;
        box-shadow: none;
      }
    }
    .send-btn {
      position: absolute;
      right: 10px;
      bottom: 10px;
    }
  }
  .cm-list {
    padding: 30px 20px 10px 20px;
    height: 100%;
    .cm-item {
      margin-bottom: 20px;
      .cm-item-avatar {
        min-width: 32px;
      }
      .time-title {
        color: rgba(85, 85, 85, 0.5);
        font-size: 12px;
        text-align: center;
        margin-bottom: 20px;
      }
      .main-message {
        display: flex;
        .user-message-item {
          margin-left: 12px;
          position: relative;
          .content-info {
            background-color: #fff;
            padding: 6px 12px;
            border-radius: 4px;
            font-size: 14px;
            position: relative;
            &.img-info {
              padding: 0;
              background-color: #fff;
              img {
                cursor: pointer;
                border-radius: 4px;
              }
            }
            &::after {
              position: absolute;
              content: "";
              width: 0;
              height: 0;
              right: 100%;
              top: 10px;
              border-top: 5px solid transparent;
              border-right: 7px solid #fff;
              border-bottom: 5px solid transparent;
            }
          }
          .send-fail {
            position: absolute;
            left: 0;
            bottom: -18px;
            font-size: 12px;
            color: #ec4958;
          }
        }
        &.merchant {
          flex-direction: row-reverse;
          .cm-item-avatar {
            flex-shrink: 0;
          }
          .content-info {
            margin-left: 0px;
            margin-right: 12px;
            background-color: #8fec78;
            &::after {
              position: absolute;
              content: "";
              width: 0;
              height: 0;
              right: 0;
              left: 100%;
              top: 10px;
              border-right: 0;
              border-top: 5px solid transparent;
              border-left: 7px solid #8fec78;
              border-bottom: 5px solid transparent;
            }
          }
        }
      }
    }
  }
}
aside .sidebar-scrollbar,
.cm-list,
.input-content textarea {
  overflow: hidden;
  .user-item {
    padding-right: 18px;
  }
  &.cm-list {
    padding-right: 28px;
  }
  &::-webkit-scrollbar {
    width: 8px;
    background-color: #f3f3f3;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #ddd;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #f3f3f3;
  }
  &:hover {
    padding-right: 0;
    overflow: auto;
    .user-item {
      padding-right: 20px;
    }
    &.cm-list {
      padding-right: 20px;
    }
    .input-content {
      padding-right: 26px;
    }
  }
}
.order-info {
  position: absolute;
  right: 0;
  top: 0;
  width: 200px;
  height: 100%;
  transform: translateX(100%);
  background-color: #f3f3f3;
  border: 1px solid #ddd;
  padding: 10px;
  font-size: 12px;
  overflow: auto;
  .order-title {
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
  }
  .detail-item {
    line-height: 24px;
    .label {
      font-weight: 500;
    }
  }
  .no-order {
    text-align: center;
    margin-top: 20px;
  }
}
.icon-tab {
  font-size: 20px;
  margin-left: 10px;
  cursor: pointer;
}
.emoji-list {
  .emoji-item {
    padding: 8px;
    cursor: pointer;
    font-size: 20px;
  }
}
.img-dialog {
  .header {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: transparent;
    left: 0;
    top: 0;
  }
}
</style>
